// TODO: delete when new customize UI enabled for everyone
import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import InputStore from './InputStore';

export default class EditCustomPageContentStore {
    static PropType = PropTypes.shape({
        messageStore: InputStore.PropType.isRequired,
        hasChanged: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
        validator: PropTypes.func,
    });

    constructor(data = {}) {
        this.validator = () => true;
        extendObservable(this, /** @class EditCustomPageContentStore */{
            type: null,
            defaultValue: {},
            message: '',
            messageStore: new InputStore(),

            hasChanged() {
                return !this.messageStore.equals(this.message);
            },

            isValid() {
                return this.validator(this.messageStore.value);
            },
        }, data);
    }

    setValue = action((message) => {
        this.message = message;
        this.messageStore.setValue(message);
    });
}
